export class RedirectRule {
  id;
  clientId;
  strategyId;
  dayOfWeek;
  periodStart;
  periodEnd;
  deviceType;
  redirect;
  numberOfLogin = 0;
  redirectOptIn;

  constructor(obj?: Location) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/redirect-strategies/redirect-rule.model.ts